var map = {
	"./pop-album-1.png": 94486,
	"./pop-album-2.png": 85165,
	"./pop-album-3.png": 59012,
	"./pop-album-4.png": 52603,
	"./pop-album-5.png": 3602,
	"./pop-album-6.png": 68745,
	"./pop-album-7.png": 13920,
	"./pop-album-8.png": 41191,
	"./pop-album-9.png": 69854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69639;